import { apiClient } from "lib/apiClient";

export type UploadPropertyErrorType = {
  message: string;
};

type Response = {
  validationErrors: UploadPropertyErrorType[];
  state: "SUCCESS" | "ERROR";
  savedProperties: number;
};

export const uploadPropertyXlsxFile = async (
  userId: string,
  file: FormData
): Promise<Response> => {
  const response = await apiClient.post(
    `/properties/upload/user/${userId}`,
    file
  );

  return response.data;
};
